import {OrdersDetailSubjectType, OrdersDetailType} from "../interface";
import {Control, UseFormGetValues, UseFormRegister, UseFormSetValue} from "react-hook-form";
import {useModal} from "../../../../../hooks";
import {useReadCurrencyTypeSelectBox} from "../../create/hooks/useReadCurrencyTypeSelectBox";
import {
    useReadExchangeType1SelectBox,
    useReadExchangeType2SelectBox,
    useReadExchangeType3SelectBox
} from "../../../../customer/correspondent/detail/hooks";
import {
    useReadExchangeRateUnitSelectBoxApi
} from "../../../../customer/correspondent/detail/hooks/useReadExchangeRateUnitSelectBox";
import {useReadWonUnitSelectBox} from "../../../../customer/correspondent/detail/hooks/useReadWonUnitSelectBox";
import {useReadShipmentExchangeRate} from "../hooks/useReadShipmentExchangeRate";
import React, {useCallback, useEffect, useState, useMemo } from "react";    // 내부수정: useMemo 추가
import moment from "moment";
import {CommonSelectType} from "../../../../../types/common/basic";
import {ordersDetailSubjectElementInit} from "../state";
import SearchProductInner from "../../../../../components/common/modal/inner/SearchProductInner";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {usePriceSetter} from "../hooks/usePriceSetter";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import { useUser } from "../../../../../util/userContext/UserContext";
import {useReadNewProductGroup} from "../../../../main/sales/expected/hooks/useReadNewProductGroup";  // 내부수정: 제품군 셀렉트 박스


interface PropsUpper {
    watchUpdateSubject: OrdersDetailSubjectType
    btnSave: () => any
    btnToggleModify: () => any
    isModify: string
    register: UseFormRegister<OrdersDetailSubjectType>
    getValues: UseFormGetValues<OrdersDetailSubjectType>
    setValue: UseFormSetValue<OrdersDetailSubjectType>
}

interface PropsLower {
    wonUnit: string | null
    isDeadline: boolean | undefined
    ordersDetail: OrdersDetailType
    control: Control<OrdersDetailSubjectType>
}

export default function Tab2Modify({
                                       watchUpdateSubject,
                                       btnSave,
                                       btnToggleModify,
                                       isModify,
                                       register,
                                       getValues,
                                       setValue,
                                       wonUnit,
                                       isDeadline,
                                       ordersDetail,
                                       control
                                   }: PropsUpper & PropsLower) {
    //const isDisabledUpdateSubject = !((ordersDetail.newPProgress === 100000000 || ordersDetail.newPProgress === 100000001) && !isDeadline)
    // 내부수정: 수주 상태일 때만 품목 수정 가능 (출하요청도 disable 처리)
    const isDisabledUpdateSubject = !(ordersDetail.newPProgress === 100000000 && !isDeadline)

    const { user} = useUser();
    const {handleModal} = useModal();

    // 내부수정: 제품군 셀렉트 박스
    const {data: productGroupList} = useReadNewProductGroup({enabled: true});

    // 내부수정: KRW 여부 판단 (매출액/원화매출액 컬럼 조건부 표시)
    const isKRW = watchUpdateSubject.newPCurrency == 100000000;

    const productGroupOptions = useMemo(() => {
        return productGroupList
            ? productGroupList.map((el: any) => <option value={el.newProductGroupid}>{el.newName}</option>)
            : <></>
    }, [productGroupList])

    const onChangeProductGroup = (idx: number, value: string) => {
        const selectedGroup = productGroupList?.find((el: any) => el.newProductGroupid === value)

        const list = getValues("list").map((el, idx2) => {
            if (idx === idx2) {
                return {
                    ...el,
                    _new_l_product_group_value: value,
                    productGroupName: selectedGroup?.newName ?? "",
                    _new_l_erp_product_value: "",
                    newTxtNmItem: "",
                    new_txt_standard: "",
                }
            } else {
                return el
            }
        })
        setValue("list", list)
    }

    const {data: currencyList} = useReadCurrencyTypeSelectBox()
    const {data: exchangeTypeSelect1} = useReadExchangeType1SelectBox();
    const {data: exchangeTypeSelect2} = useReadExchangeType2SelectBox();
    const {data: exchangeTypeSelect3} = useReadExchangeType3SelectBox();
    const {data: exchangeRateUnitSelect} = useReadExchangeRateUnitSelectBoxApi();
    const {data: wonUnitSelect} = useReadWonUnitSelectBox();

    const {mutateAsync: mutateAsyncReadShipmentExchangeRate} = useReadShipmentExchangeRate()

    const watchKeywordType2 = watchUpdateSubject.exchangeRateCondition1
    useEffect(() => {
    if (watchUpdateSubject.newPCurrency == 100000000) {
            setValue("newDExchangeRate", 1)
            setValue("exchangeRateCondition1", "")
            setValue("startAt", "")
            setValue("endAt", "")
        } else {
            // 내부수정: 조건 변경 없이 날짜만 계산
            if (!watchKeywordType2 || watchKeywordType2 == "200") {
                setValue("startAt", moment().format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
            }
            if (watchKeywordType2 == "201") {
                setValue("startAt", moment().startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
            }
            if (watchKeywordType2 == "202") {
                setValue("startAt", moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"))
            }
            if (watchKeywordType2 == "204") {
                setValue("startAt", moment().startOf("month").format("YYYY-MM-DD"))
                setValue("endAt", moment().format("YYYY-MM-DD"))
            }
        }
    }, [watchUpdateSubject.newPCurrency, watchUpdateSubject.exchangeRateCondition1]);

    const watchStartAt = watchUpdateSubject.startAt
    useEffect(() => {
        if (watchUpdateSubject.exchangeRateCondition1 == "205") {
            setValue("endAt", watchStartAt)
        }
    }, [watchStartAt]);

    const watchEndAt = watchUpdateSubject.endAt
    useEffect(() => {
        if (watchUpdateSubject.exchangeRateCondition1 == "205") {
            setValue("startAt", watchEndAt)
        }
    }, [watchEndAt]);

    const btnSearch = () => {
        if (watchKeywordType2 == "205" && watchStartAt !== watchEndAt) {
            handleModal({
                isOpen: true,
                contents: "지정일은 범위 형식일 수 없습니다.",
                type: "alert",
            });
        } else {
            const param = {
                exchangeReq: {
                    endAt: watchUpdateSubject.endAt,
                    startAt: watchUpdateSubject.startAt,
                    keywordType: watchUpdateSubject.exchangeRateCondition2 ?? "",
                    keywordType2: watchUpdateSubject.exchangeRateCondition1 ?? "",
                    keywordType2Name: exchangeTypeSelect1?.find(el => el.id == watchUpdateSubject.exchangeRateCondition1)?.name ?? "",
                },
                rateType: watchUpdateSubject.exchangeRateCondition3 ? String(watchUpdateSubject.exchangeRateCondition3) : null,
                regionType: watchUpdateSubject.newPCurrency ? String(watchUpdateSubject.newPCurrency) : null,
                showType: watchUpdateSubject.exchangeRateUnit ? String(watchUpdateSubject.exchangeRateUnit) : null
            }

            if (param.exchangeReq.keywordType === "" ||
                !param.rateType ||
                !param.regionType ||
                !param.showType) {
                handleModal({
                    isOpen: true,
                    contents: "환율 지정 조건이 없습니다.",
                    type: "alert",
                });
            } else {
                mutateAsyncReadShipmentExchangeRate(param).then(res => {
                    if (res?.data?.code !== "0000") {
                        handleModal({
                            isOpen: true,
                            contents: res?.data?.msg,
                            type: "alert",
                        });
                    } else {
                        setValue("newDExchangeRate", res.data.result ?? 0)
                    }
                })
            }
        }
    }

    const [checkedIdx, setCheckedIdx] = useState<number[]>([])

    const isAllCheck = watchUpdateSubject.list.length !== 0
        && watchUpdateSubject.list.every((el, idx) => checkedIdx.includes(idx))

    const clickCheck = (idx: number) => {
        if (checkedIdx.includes(idx)) {
            setCheckedIdx(checkedIdx.filter(el => el !== idx))
        } else {
            setCheckedIdx([...checkedIdx, idx])
        }
    }

    const clickAllCheck = () => {
        if (!isAllCheck) {
            setCheckedIdx(Array.from({length: watchUpdateSubject.list.length}, (_, i) => i))
        } else {
            setCheckedIdx([])
        }
    }

    const btnAdd = () => {
        const list = [...getValues("list"), {
            ...ordersDetailSubjectElementInit,
            new_p_currency: String(getValues('newPCurrency') ?? '')
        }]

        setValue("list", list)
    }

    const btnDelete = () => {
        const list = getValues("list").filter((_, idx) => !checkedIdx.includes(idx))

        setValue("list", list)
    }

    const btnSearchProduct = useCallback((idx: number) => {
        // 내부수정: 제품군 셀렉트 박스
        const selectedGroupId = getValues(`list.${idx}._new_l_product_group_value`)
        const selectedGroupName = productGroupList?.find((el: any) => el.newProductGroupid === selectedGroupId)?.newName ?? ""

        handleModal({
            isOpen: true,
            contents: <SearchProductInner
                productGroupName={selectedGroupName}  // 내부수정: 제품군 셀렉트 박스
                confirmCallback={(item) => {
                    const product = item.productDetailRes

                    const list = getValues("list").map((el, idx2) => {
                        if (idx === idx2) {
                            return {
                                ...el,
                                _new_l_erp_product_value: product.newErpProductid,
                                newTxtNmItem: product.newTxtNmItem,
                                new_txt_standard: product.newTxtStndItem,
                                _new_l_product_group_value: product.newLProductGroupValue,
                                productGroupName: product.productRange,
                                _new_l_shipment_value: ordersDetail.newShipmentId
                            }
                        } else {
                            return el
                        }
                    })

                    setValue("list", list)
                }}
                modalDepth={1}
            />,
            type: "",
            title: "제품 조회",
            modalSize: "xxl"
        })
    }, [productGroupList])

    const {applyCurrencyValue, isNanSumValue, sumValue} = usePriceSetter(wonUnit, watchUpdateSubject.newDExchangeRate)

    return <>
        <div className="content_wrap">
            <div className="table_top">
                <h6 className="table_stats">환율 정보</h6>
                <div className="table_toolbar">
                    <button className="btn btn-primary w-100px" onClick={btnSave}>
                        저장
                    </button>
                    <button className="btn btn-outline-secondary w-100px" onClick={btnToggleModify}>
                        취소
                    </button>
                </div>
            </div>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        {/* 내부수정: 환율 환종 자리 변경 */}
                        <th style={{width: "16.66%"}}>환종</th>
                        <td className="p-4px">
                            <select className="form-select"
                                    value={watchUpdateSubject.newPCurrency ?? 0}
                                    {...register("newPCurrency")}>
                                {currencyList?.map((item: CommonSelectType) => {
                                    return <option value={item.id}
                                                   hidden={item.id === 100000002 || item.id === 100000003}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                        <th style={{width: "16.66%"}}>환율</th>
                        <td style={{width: "33.33%"}}>{watchUpdateSubject.newDExchangeRate}</td>
                    </tr>
                    <tr>
                        <th>기준일</th>
                        <td className="p-4px">
                            <select className="form-select"
                                    value={watchUpdateSubject.exchangeRateCondition1 ?? 0}
                                    disabled={watchUpdateSubject.newPCurrency == 100000000}
                                    {...register("exchangeRateCondition1")}
                            >
                                <option value={undefined} hidden></option>
                                {exchangeTypeSelect1?.map((item) => {
                                    return <option value={item.id}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                        <td colSpan={2} className="p-4px">
                            <div className="d-flex justify-content-between align-items-center">
                                <input type="date"
                                       className="form-control"
                                       max="9999-12-31"
                                       disabled={watchUpdateSubject.newPCurrency == 100000000 ||
                                           watchKeywordType2 == "200" ||
                                           watchKeywordType2 == "201" ||
                                           watchKeywordType2 == "202" ||
                                           watchKeywordType2 == "204"
                                       }
                                       value={watchUpdateSubject.startAt}
                                       {...register("startAt")}/>
                                <span className="txt_range mx-2">~</span>
                                <input type="date"
                                       className="form-control"
                                       max="9999-12-31"
                                       disabled={watchUpdateSubject.newPCurrency == 100000000 ||
                                           watchKeywordType2 == "200" ||
                                           watchKeywordType2 == "201" ||
                                           watchKeywordType2 == "202" ||
                                           watchKeywordType2 == "204"}
                                       value={watchUpdateSubject.endAt}
                                       {...register("endAt")}/>
                                <button className="btn btn-info btn_search ms-2"
                                        disabled={watchUpdateSubject.newPCurrency == 100000000}
                                        onClick={btnSearch}>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>기준일 메모</th>
                        <td colSpan={3} className="p-4px">
                            <input type="text"
                                   className="form-control"
                                   value={watchUpdateSubject.exchangeDateMemo}
                                   {...register("exchangeDateMemo")}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>환율 지정 조건</th>
                        <td colSpan={3} className="p-4px">
                            <div className="d-flex align-items-center">
                                <select className="form-select" value={watchUpdateSubject.exchangeRateCondition2 ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeTypeSelect2?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                                <select className="form-select ms-1"
                                        value={watchUpdateSubject.exchangeRateCondition3 ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeTypeSelect3?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                                <select className="form-select ms-1" value={watchUpdateSubject.exchangeRateUnit ?? 0}
                                        disabled>
                                    <option value={undefined} hidden></option>
                                    {exchangeRateUnitSelect?.map((item) => {
                                        return <option value={item.id}>{item?.name}</option>;
                                    })}
                                </select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>원화 단가 단위</th>
                        <td colSpan={3} className="p-4px">
                            <select className="form-select"
                                    value={watchUpdateSubject.wonUnit ?? 0}
                                    {...register("wonUnit")}
                                    disabled={Number(user?.inOutFlag) === 1}>
                                <option value={""}>선택</option>
                                {wonUnitSelect?.map((item) => {
                                    return <option value={item.id}>{item?.name}</option>;
                                })}
                            </select>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="content_wrap">
            <div className="table_top">
                <h6 className="table_stats">수주 품목</h6>
                <div className="table_toolbar">
                    <button className="btn btn-dark w-80px" onClick={btnAdd} disabled={isDisabledUpdateSubject}>추가
                    </button>
                    <button className="btn btn-outline-dark w-100px px-0" onClick={btnDelete}
                            disabled={isDisabledUpdateSubject}>
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>
                        선택삭제
                    </button>
                </div>
            </div>
            <div className="table_scroll mb-0">
                <table className="table table-bordered my_table table_detail">
                    <thead>
                    <tr>
                        <th style={{width: "3%"}}>
                            <div className="checkbox_outer">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isAllCheck}
                                    onClick={clickAllCheck}
                                    disabled={isDisabledUpdateSubject}
                                />
                            </div>
                        </th>
                        <th style={{width: "10%"}}>제품군</th>
                        <th>품목</th>
                        <th style={{width: "13%"}}>규격</th>
                        <th style={{width: "8%"}}>단가</th>
                        {/* 내부수정: KRW일 경우 원화단가/원화매출액 컬럼 미표시 */}
                        {!isKRW && <th style={{width: "8%"}}>원화 단가</th>}
                        <th style={{width: "8%"}}>수량</th>
                        <th style={{width: "10%"}}>매출액</th>
                        {!isKRW && <th style={{width: "10%"}}>원화 매출액</th>}
                    </tr>
                    </thead>
                    <tbody>
                    {watchUpdateSubject.list.length !== 0
                        ? watchUpdateSubject.list.map((el, idx) =>
                            <tr>
                                <td>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={checkedIdx.includes(idx)}
                                            onClick={() => clickCheck(idx)}
                                            disabled={isDisabledUpdateSubject}
                                        />
                                    </div>
                                </td>
                                {/* 내부수정: 제품군 셀렉트 박스 추가
                                <td className="p-4px">
                                    <input type="text" className="form-control"
                                           value={el.productGroupName}
                                           disabled/>
                                </td> */}
                                <td className="p-4px">
                                    <select
                                        className="form-select"
                                        value={el._new_l_product_group_value}
                                        onChange={e => onChangeProductGroup(idx, e.target.value)}
                                        disabled={isDisabledUpdateSubject}
                                    >
                                        <option value={""}>선택</option>
                                        {productGroupOptions}
                                    </select>
                                </td>
                                <td className="p-4px">
                                    <div className="d-flex">
                                        <input type="text" className="form-control"
                                               value={el.newTxtNmItem}
                                               disabled/>
                                        <button
                                            className="btn btn-info btn_search w-100px ms-5px"
                                            onClick={() => btnSearchProduct(idx)}
                                            disabled={isDisabledUpdateSubject}>
                                            <img
                                                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                                alt=""
                                            />찾기
                                        </button>
                                    </div>
                                </td>
                                <td className="p-4px">
                                    <input type="text" className="form-control"
                                           value={el.new_txt_standard}
                                           disabled/>
                                </td>
                                <td className="p-4px">
                                    <InputNumberUc control={control} name={`list.${idx}.new_d_unitprice`}
                                                   disabled={isDisabledUpdateSubject}/>
                                </td>
                                {/* 내부수정: KRW일 경우 원화단가 미표시 */}
                                {!isKRW &&
                                    <td className="text-end">
                                        <DisplayNumber value={applyCurrencyValue(el.new_d_unitprice)}/>
                                    </td>
                                }
                                <td className="p-4px">
                                    <InputNumberUc control={control} name={`list.${idx}.new_i_qty`}
                                                   disabled={isDisabledUpdateSubject}/>
                                    {/*<input type="text" className="form-control text-end"
                                           value={el.new_i_qty}
                                           {...register(`list.${idx}.new_i_qty`)}
                                           disabled={isDisabledUpdateSubject}/>*/}
                                </td>
                                {/* 내부수정: 매출액(통화 원본) 추가, KRW일 경우 원화매출액 미표시 */}
                                <td className="text-end">
                                    <DisplayNumber value={el.new_d_unitprice * Number(el.new_i_qty)}/>
                                </td>
                                {!isKRW &&
                                    <td className="text-end">
                                        <DisplayNumber value={applyCurrencyValue(el.new_d_unitprice) * Number(el.new_i_qty)}/>
                                    </td>
                                }
                            </tr>
                        )
                        : <EmptyTableRow colSpan={isKRW ? 6 : 8} msg={`수주 품목을 추가해주세요.`}/>
                    }
                    </tbody>
                    <tfoot>
                    <tr>
                        {/* 내부수정: KRW 여부에 따라 colSpan 조정 */}
                        <td className="text-start grey" colSpan={isKRW ? 5 : 6}></td>
                        <td className="text-end">
                            {isNanSumValue(watchUpdateSubject.list.map(el => el.new_i_qty)) ? <>-</> :
                                <DisplayNumber
                                    value={Number(sumValue(watchUpdateSubject.list.map(el => el.new_i_qty)))}/>}
                        </td>
                        {/* 내부수정: 매출액 합계 */}
                        <td className="text-end">
                            {isNanSumValue(watchUpdateSubject.list.map(el => el.new_d_unitprice)) ? <>-</> :
                                <DisplayNumber
                                    value={Number(sumValue(watchUpdateSubject.list.map(el => el.new_d_unitprice * Number(el.new_i_qty))))}/>}
                        </td>
                        {/* 내부수정: KRW일 경우 원화매출액 합계 미표시 */}
                        {!isKRW &&
                            <td className="text-end">
                                {isNanSumValue(watchUpdateSubject.list.map(el => el.new_d_won)) ? <>-</> :
                                    <DisplayNumber
                                        value={Number(sumValue(watchUpdateSubject.list.map(el => applyCurrencyValue(el.new_d_unitprice) * Number(el.new_i_qty))))}/>}
                            </td>
                        }
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </>
}